export enum TranslationActionTypes {
  SET_LANGUAGE = "@loading/setLanguage"
}

export interface ITranslationState {
  readonly language: string;
}

export interface ISetLanguage {
  type: TranslationActionTypes.SET_LANGUAGE;
  payload: string;
}

export type TranslationActions = ISetLanguage;
